module.exports = __webpack_public_path__ + "static/media/success.213e3fab.svg";